import React from 'react';
import { beyondWork, personalPhotos } from '../data/personal';
import '../styles/personal-photos.css';

export default function BeyondWork() {
  const photo = personalPhotos.lake;
  return <section className="beyond-work" aria-labelledby="beyond-work-title">
    <img src={photo.src} srcSet={photo.srcSet} sizes="(max-width: 600px) calc(100vw - 40px), 360px" alt={photo.alt} width={800} height={1000} loading="lazy" decoding="async"/>
    <div><p className="section-kicker">{beyondWork.title}</p><h2 id="beyond-work-title">{beyondWork.heading}</h2>{beyondWork.paragraphs.map(paragraph => <p key={paragraph}>{paragraph.split(/(Harry Potter|David Copperfield)/).map((part, index) => part === 'Harry Potter' || part === 'David Copperfield' ? <em key={index}>{part}</em> : part)}</p>)}</div>
  </section>;
}
